module.exports = __webpack_public_path__ + "img/team-dark-04.8f312446.jpg";